import React, { useState, useEffect } from "react";
import { Autocomplete, TextField, Box, IconButton } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";
import { UseCountry } from "./UseCountry";

export default function CountryAutocomplete(props) {
  const { getAllCountryList } = UseCountry();
  const [productCountryRes, setProductCountryRes] = useState();
  const [selectedCountries, setSelectedCountries] = useState();

  useEffect(() => {
    getAllCountryList((countries) => {
      setProductCountryRes(countries);
    });
  }, []);

  useEffect(() => {
    if (selectedCountries) {
      props.setter({
        ...props.lvl1State,
        countryID: selectedCountries.id,
      });
    }
  }, [selectedCountries]);

  useEffect(() => {
    if (productCountryRes && props.selectedCountryID) {
      setSelectedCountries(
        productCountryRes.countries.find((m) => m.id == props.selectedCountryID)
      );
    }
  }, [productCountryRes, props.selectedCountryID]);

  return productCountryRes ? (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: props.cluster && "100%",
      }}
    >
      <Autocomplete
        // disablePortal
        id="combo-box-demo"
        value={selectedCountries ? selectedCountries : ""}
        options={productCountryRes.countries ? productCountryRes.countries : []}
        getOptionLabel={(countries) =>
          countries.faName ? countries.faName : ""
        }
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => (
          <TextField error={props.validation} {...params} label="کشور" />
        )}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.faName ? option.faName : ""}
            </li>
          );
        }}
        onChange={(evt, newValue) => {
          if (newValue) {
            setSelectedCountries(newValue);
          } else {
            setSelectedCountries();
            props.setter({
              ...props.lvl1State,
              countryID: 0,
            });
          }
        }}
        fullWidth
        size="small"
      />
      <IconButton
        sx={{ p: 0, m: 1 }}
        onClick={() => {
          getAllCountryList((countries) => {
            setProductCountryRes(countries);
          });
        }}
      >
        <CachedIcon fontSize="small" />
      </IconButton>
      <IconButton sx={{ p: 0 }} href="/Countries" target="_blank">
        <LinkIcon fontSize="small" />
      </IconButton>
    </Box>
  ) : (
    ""
  );
}
